// extracted by mini-css-extract-plugin
export default {"nameCellWrapper":"Members_nameCellWrapper__jv1d9","nameWrapper":"Members_nameWrapper__WArSD"};